if (!customElements.get("subscription-widget")) {
  customElements.define(
    "subscription-widget",
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();

        this.options = this.querySelectorAll("subscription-widget-option");

        this.initOptions();
      }

      initOptions() {

        // make sure that one option is always selected by default
        setTimeout(() => {
          if (this.options.length > 0) {
            // Automatically select the first option if none is selected
            this.options[0].check();
          }
        }, 0);
      }
    },
  );
}
